export const getDiscretePurchasePrice = (
  initialPrice,
  decayConstant,
  scaleFactor,
  totalPurchases,
  timeSinceStart,
  purchaseQuantity
) => {
  const t1 = initialPrice * Math.pow(scaleFactor, totalPurchases);
  const t2 = Math.pow(scaleFactor, purchaseQuantity) - 1;
  const t3 = Math.exp(decayConstant * timeSinceStart);
  const t4 = scaleFactor - 1;

  return (t1 * t2) / (t3 * t4);
};
